/* eslint-disable @nx/enforce-module-boundaries */
import { AspectRatio, buildDynamicRenditionPath, HeightRatioFromAspectRatio } from '@marriott/mi-web-ui-kit';

/** Aspect ratio values for use by slotPropNormalizers (avoids mi-web-ui-kit import in product-components) */
export const ASPECT_RATIOS = {
  SQUARE: AspectRatio.SQUARE,
  WIDE_HOR: AspectRatio.WIDE_HOR,
  CLASSIC_VER: AspectRatio.CLASSIC_VER,
} as const;

export const buildDynamicMediaNode = (assetUrl?: string, aspectRatio?: AspectRatio, altText?: string) => {
  if (!assetUrl) return;

  const widthXL = 1200;
  const widthLG = 992;
  const widthMD = 768;
  const widthSM = 576;

  const ratio = (HeightRatioFromAspectRatio.get(aspectRatio || AspectRatio.SQUARE) as number) || 1;

  const xlSrcSet = buildDynamicRenditionPath(assetUrl, aspectRatio, widthXL);
  const lgSrcSet = buildDynamicRenditionPath(assetUrl, aspectRatio, widthLG);
  const mdSrcSet = buildDynamicRenditionPath(assetUrl, aspectRatio, widthMD);
  const smSrcSet = buildDynamicRenditionPath(assetUrl, aspectRatio, widthSM);

  return {
    altText: altText || '',
    assetPath: assetUrl,
    enableSmartCrop: true,
    dynamic: true,
    renditions: [
      {
        renditionPath: xlSrcSet,
        dynamic: true,
        mediaValue: `${widthXL}px`,
        mediaQuery: 'min-width',
        damPath: assetUrl,
        width: widthXL,
        height: Math.round(widthXL / ratio),
      },
      {
        renditionPath: lgSrcSet,
        dynamic: true,
        mediaValue: `${widthLG}px`,
        mediaQuery: 'min-width',
        damPath: assetUrl,
        width: widthLG,
        height: Math.round(widthLG / ratio),
      },
      {
        renditionPath: mdSrcSet,
        mediaQuery: 'min-width',
        dynamic: true,
        mediaValue: `${widthMD}px`,
        damPath: assetUrl,
        width: widthMD,
        height: Math.round(widthMD / ratio),
      },
      {
        renditionPath: smSrcSet,
        mediaQuery: 'min-width',
        dynamic: true,
        mediaValue: `${widthSM}px`,
        damPath: assetUrl,
        width: widthSM,
        height: Math.round(widthSM / ratio),
      },
    ],
    damPath: assetUrl,
  };
};
